import { Checkout, CheckoutStatus } from '@40seas/entities/checkout';
import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateCheckoutDto extends Omit(Checkout, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: CheckoutStatus;
}
